import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const chartTextowasp = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 500 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The below chart depicts the number of discovered vulnerabilities mapped to OWASP/ MSTG 2024 testing category.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: false,
            bold: false
        }),
    ],
})
